import { render, staticRenderFns } from "./zgdxkd.vue?vue&type=template&id=1ac34360&scoped=true"
import script from "./zgdxkd.vue?vue&type=script&lang=js"
export * from "./zgdxkd.vue?vue&type=script&lang=js"
import style0 from "./zgdxkd.vue?vue&type=style&index=0&id=1ac34360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac34360",
  null
  
)

export default component.exports